import { Pipe } from '@angular/core';
import { empty } from '../utils/utils';
var EmptyPipe = (function () {
    function EmptyPipe() {
    }
    EmptyPipe.prototype.transform = function (input) {
        return empty(input);
    };
    return EmptyPipe;
}());
export { EmptyPipe };
EmptyPipe.decorators = [
    { type: Pipe, args: [{
                name: 'empty'
            },] },
];
/** @nocollapse */
EmptyPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=empty.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/empty.pipe.js
// module id = 231
// module chunks = 103